module.exports = __webpack_public_path__ + "img/pollo_n11.21d395b3.png";